import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import Bugsnag from '@bugsnag/js';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { AngularRoutingProvider } from '@bugsnag/angular-performance';
import { shouldReportToBugsnag } from '@core/bugsnag/ignored-errors';
import { environment } from '@env';

const BUGSNAG_API_KEY = '050aba1604720afda2d54204e2008538';
const releaseStage = environment.production ? 'production' : environment.isDev ? 'development' : 'testing';

// Not registering @bugsnag/plugin-angular's `plugin` here: its `_notify` wrapper (meant to keep
// notify calls out of Angular's zone) calls the client's original _notify unbound, throwing
// "Cannot read properties of undefined (reading '_config')" and swallowing every error report.
// This app is zoneless anyway, so the plugin's zone-avoidance has no purpose here.
// BugsnagErrorHandler (app.config.ts) is constructed directly instead, which works correctly.
Bugsnag.start({
  apiKey: BUGSNAG_API_KEY,
  releaseStage,
  // Returning false discards the event. See ignored-errors.ts for what is
  // filtered and why.
  onError: (event) => shouldReportToBugsnag(event.errors),
});

BugsnagPerformance.start({
  apiKey: BUGSNAG_API_KEY,
  routingProvider: new AngularRoutingProvider(),
  releaseStage,
  samplingProbability: 1.0,
});

async function bootstrap(): Promise<void> {
  if (environment.production && environment.useMockApi) {
    throw new Error('Misconfiguration: useMockApi must be false in production environments. Refusing to bootstrap.');
  }
  if (environment.useMockApi) {
    const { startMockWorker } = await import('./app/mocks');
    await startMockWorker();
  }
  await bootstrapApplication(App, appConfig);
}

bootstrap().catch((err) => console.error(err));
